module.exports = __webpack_public_path__ + "img/1562460039.561fa0eb.jpg";